import ReportCard from "../../../../../../components/reports/report-card.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {useEffect} from "react";

export default function CardsContent({ data, boName }) {
    const encounterCards = data?.encounterCards?.[0] ?? {};

    useEffect(() => {
        const tableRows = [
            ["Total de abordagens", encounterCards?.encounters ?? 0],
            ["Indivíduos abordados", encounterCards?.individuals ?? 0],
            ["Indivíduos com associação", encounterCards?.ind_association ?? 0],
            [`${boName} cadastrados`, encounterCards?.bo ?? 0],
            ["Veículos abordados", encounterCards?.vehicles ?? 0],
            ["Veículos com associação", encounterCards?.vehicle_association ?? 0],
        ];

        ReportUtils.createExportableTable(
            ["Descrição", "Quantidade"],
            tableRows,
            "Cards",
        );
    }, [encounterCards]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3 gap-2">
                    <ReportCard
                        title="Total de abordagens"
                        value={encounterCards?.encounters ?? 0}
                    />
                    <ReportCard
                        title="Indivíduos abordados"
                        value={encounterCards?.individuals ?? 0}
                    />
                    <ReportCard
                        title="Indivíduos com associação"
                        idTitle={`Indivíduos associados à ${boName} e Ocorrências do Sentry`}
                        value={encounterCards?.ind_association ?? 0}
                    />
                </div>
                <div className="grid grid-cols-3 gap-2">
                    <ReportCard
                        title={`${boName} cadastrados`}
                        value={encounterCards?.bo ?? 0}
                    />
                    <ReportCard
                        title="Veículos abordados"
                        value={encounterCards?.vehicles ?? 0}
                    />
                    <ReportCard
                        title="Veículos com associação"
                        idTitle={`Veículos associados à ${boName} e Ocorrências do Sentry`}
                        value={encounterCards?.vehicle_association ?? 0}
                    />
                </div>
            </div>
            <div className="chart-divisor" />
        </>
    )
}